import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../../../box/src";
const StyledList = styled.ul `
  list-style: disc;
`;
export const Content = forwardRef(({ cookieList, typeDescription }, ref) => (_jsxs(Box, { flexDirection: "column", ref: ref, width: "80%", children: [_jsx(Box, { ml: 7, children: typeDescription }), _jsx(Box, { mb: 3, ml: 10, children: _jsx(StyledList, { children: cookieList.map((item, index) => (_jsx("li", { children: _jsx(Box, { mt: 3, children: item.description }) }, `${item.service_name}-${item.name}`))) }) })] })));
//# sourceMappingURL=Content.js.map